var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPendingCredit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pending-credit_svg__a",
  x1: "100%",
  x2: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7991C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FC780B"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-664-194H776v1228H-664z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#pending-credit_svg__a)",
  d: "m15.89 0 1.013 4.304-4.13.332 1.09-1.62A8.2 8.2 0 0 0 9.786 1.93c-4.566 0-8.281 3.715-8.281 8.283 0 4.566 3.715 8.281 8.281 8.281V20C4.392 20 0 15.61 0 10.213S4.392.424 9.787.424c1.756 0 3.435.463 4.921 1.333zm-4.162 18.067c.529 0 .96.431.96.96a.962.962 0 0 1-1.921 0c0-.529.43-.96.96-.96zm2.848-.967c.53 0 .961.431.961.96a.961.961 0 0 1-1.922.001c0-.53.432-.961.961-.961m2.258-1.819a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.919zm1.516-2.306c.529 0 .96.431.96.96s-.431.96-.96.96a.96.96 0 0 1 0-1.92m-8.212-9.158.008 6.428 5.665 2.728-.653 1.357-6.517-3.137-.01-7.374zm8.901 6.578c.53 0 .961.431.961.96a.962.962 0 0 1-1.922 0c0-.529.433-.96.961-.96m-.15-2.82c.529 0 .96.431.96.96s-.431.96-.96.96a.96.96 0 0 1 0-1.92m-.868-2.43a.961.961 0 1 1 0 1.92.961.961 0 0 1 0-1.92"
}))));
export { SvgPendingCredit as ReactComponent };
export default __webpack_public_path__ + "static/media/pending-credit.06dbfe3d.svg";